import { NodeData } from '../../../ui/gzTree/type';
import { CompanyShort, ProtectedEntity, Specifics } from '@nirvana/shared/dtos/types/protected-entities/common';
import { NetworkTreeAction, TreeProtectedEntity } from '../../networkAppContainer/helpers/types';
import { NetworkTreeDataSource } from '../dataProvider/NetworkTreeDataSource';

export interface ProtectedEntityWithChildren extends TreeProtectedEntity {
  data?: Array<ProtectedEntityWithChildren>;
}

export interface TreeChildrenResponse {
  realNode: ProtectedEntity;
  data: Array<ProtectedEntityWithChildren>;
  hasMoreChildNodes: boolean;
}

export interface NetworkTreeStructure {
  rootNode: NodeData;
  data: Array<ProtectedEntityWithChildren>;
}

export enum NetworkTreeEvent {
  NODE_CHANGED = 'nodeChanged',
  TREE_LOADED = 'treeLoaded',
}

export interface NetworkTreeRenderData {
  dataSource?: NetworkTreeDataSource;
  hasActions?: boolean;
}

export interface TreeNodeData extends NodeData {
  // This is used in order to map frontend rename node to backend functions for updating or validating
  temporaryState?: NetworkTreeAction;
}

export interface RequiredTreeNodeData {
  _id: string;
  type: number;
  parentId: string;
  company: CompanyShort | null;
  name: string;
  path: string;
  hasMspLicense?: boolean;
  specifics: {
    inheritedLicense?: boolean;
    hasMspTrial?: boolean;
    canBeManagedByAbove?: boolean;
    rights?: {
      manageCompanies?: boolean;
    };
    maStatus?: number;
    productType?: number;
    stateCode?: number;
  };
  realNode?: any;
}

export interface TreeDetails {
  targetId: string;
  type: number;
  path: string;
  parentId: string;
  name?: string;
  specifics?: Specifics;
  companyId?: string;
}

export const EntitiesNotAllowedInTree = [
  Constants.ProtectedEntities.EPS.TYPE_COMPUTER,
  Constants.ProtectedEntities.EPS.TYPE_AD_COMPUTER,
  Constants.ProtectedEntities.EPS.TYPE_AWS_INSTANCE,
  Constants.ProtectedEntities.CONTAINERS.TYPE_CONTAINER,
];
